import { render } from "./dl-buttonnav.vue?vue&type=template&id=492692be"
import script from "./dl-buttonnav.vue?vue&type=script&lang=js"
export * from "./dl-buttonnav.vue?vue&type=script&lang=js"

import "./dl-buttonnav.vue?vue&type=style&index=0&id=492692be&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__